import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

/**
 * Legend component for delta-highlighted history grids.
 * Shows the orange highlight swatch, the change-count chip, and helper text.
 */
const DeltaHistoryLegend = () => {
  return (
    <Box sx={{ mb: 1.5, p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
        Delta Highlighting Legend:
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: 'rgba(255, 167, 38, 0.25)',
              border: '3px solid #ffa726',
              borderRadius: 0.5,
            }}
          />
          <Typography variant="caption">Changed field</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Chip size="small" label="3" color="warning" sx={{ height: 18, fontSize: 10 }} />
          <Typography variant="caption">Number of changes in version</Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">
          Hover over highlighted cells for details &bull; Versions ordered newest to oldest
        </Typography>
      </Box>
    </Box>
  );
};

export default DeltaHistoryLegend;
